import HandshakeEffect from './HandshakeEffect';
import HttpErrorResponseModel from '../../models/HttpErrorResponseModel';
import HandshakeModel from './models/HandshakeModel';
import ActionUtility from '../../utilities/ActionUtility';
import { ReduxDispatch } from '../../models/ReduxProps';
import IStore from '../../models/IStore';

type ActionUnion = undefined | HttpErrorResponseModel | HandshakeModel;

export default class HandshakeAction {
    public static readonly REQUEST_VALIDATE_HANDSHAKE: string = 'HandshakeAction.REQUEST_VALIDATE_HANDSHAKE';
    public static readonly REQUEST_VALIDATE_HANDSHAKE_FINISHED: string = 'HandshakeAction.REQUEST_VALIDATE_HANDSHAKE_FINISHED';

    public static requestValidateHandshake(signature: string, applicationId: string, app: string): any {
        return async (dispatch: ReduxDispatch<ActionUnion>, getState: () => IStore): Promise<void> => {
            await ActionUtility.createThunkEffect<HandshakeModel>(
                dispatch,
                HandshakeAction.REQUEST_VALIDATE_HANDSHAKE,
                HandshakeEffect.requestValidateHandshake,
                {
                    signature: signature,
                    applicationId: applicationId,
                    app: app,
                }
            );
        };
    }
}
